import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@shared/hooks/useAuth';
import { useAuthStore } from '../../../application/store/AuthStore';

import { resolvePostAuthRedirect } from '../../../features/connections/shopify/pendingInstall';

/**
 * Sends authenticated users without a selected company to the picker.
 * Covers session restore when a user belongs to multiple companies.
 */
const CompanySelectionGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const companyId = useAuthStore((state) => state.companyId);
  const userId = useAuthStore((state) => state.userId);
  const jwt = useAuthStore((state) => state.jwt);
  const location = useLocation();

  if (isLoading) {
    return <>{children}</>;
  }

  const needsCompanySelection = Boolean(userId && jwt && !companyId && !isAuthenticated);
  const onSelectCompanyPage = location.pathname === '/sign-in/select-company';

  if (needsCompanySelection && !onSelectCompanyPage) {
    return (
      <Navigate
        to="/sign-in/select-company"
        replace
        state={{ redirect: resolvePostAuthRedirect() }}
      />
    );
  }

  return <>{children}</>;
};

export default CompanySelectionGate;
